import { useProfile } from '@hooks/useProfile';

export const useFplTeamId = (): {
  fplTeamId: number | null;
  isLoading: boolean;
  isError: boolean;
} => {
  const { profile, isLoading, isError } = useProfile();

  return {
    fplTeamId: profile?.fplTeamId ?? null,
    isLoading,
    isError
  };
};
